<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line
      x1="1.43472"
      y1="1.29492"
      x2="12.0413"
      y2="11.9015"
      stroke="#666666"
      stroke-width="2"
      stroke-linecap="round"
      class="stroke"
    />
    <line
      x1="12.0205"
      y1="1.41421"
      x2="1.41391"
      y2="12.0208"
      stroke="#666666"
      stroke-width="2"
      stroke-linecap="round"
      class="stroke"
    />
  </svg>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/variables" as *;

.active svg {
  .stroke {
    stroke: $primary;
  }
}
.small svg {
  width: 11px;
  height: 11px;
}
.chip-close svg,
.chip-content svg {
  width: 0.593rem !important;
  height: 0.593rem !important;
}
.icon-add svg {
  transform: rotate(135deg);
}
.red {
  .stroke {
    stroke: #df252a;
  }
}
.text-white svg {
  .stroke {
    stroke: $white;
  }
}
</style>
